<div *appIsDesktop>
  @if (totalRecords) {
    <div>
      @for (user of users; track user; let userIndex = $index) {
        <mat-expansion-panel hideToggle [id]="'b2bUser-expansion-panel-' + userIndex" (opened)="onPanelOpened(userIndex)">
          <mat-expansion-panel-header [id]="'b2bUser-expansion-panel-header-' + userIndex">
            <mat-panel-title [id]="'b2bUser-expansion-panel-title-' + userIndex">
              <app-b2b-cart-summary-notifications [cartItems]="getUserCartItems(userIndex)">
              </app-b2b-cart-summary-notifications>
              <div class="title-container">
                <span>
                  <span [id]="'b2bUser-title-' + userIndex" class="title">{{ user.FirstName + ' ' + user.LastName }}</span>
                  <span [id]="'b2bUser-header-closed-' + userIndex"
                  class="crm-industrial-font icon-keyboard-arrow-down"></span>
                  <span [id]="'b2bUser-header-opened-' + userIndex"
                  class="crm-industrial-font icon-keyboard-arrow-up"></span>
                </span>
                <div [id]="'actionButtons-' + userIndex" class="action-buttons">
                  @if (user.itemsInCart > 0) {
                    <ng-container *ngTemplateOutlet="editCartButton; context: {userIndex: userIndex}"></ng-container>
                    <ng-container *ngTemplateOutlet="deleteCartButton; context: {userIndex: userIndex}"></ng-container>
                    <ng-container *ngTemplateOutlet="generateQuoteButton; context: {userIndex: userIndex}"></ng-container>
                  } @else {
                    <ng-container *ngTemplateOutlet="addToCartButton; context: {userIndex: userIndex}"></ng-container>
                  }
                </div>
              </div>
            </mat-panel-title>
            <ds-divider></ds-divider>
            <div class="user-info" [id]="'b2bUser-info-container-' + userIndex">
              @for (column of userInfoColumns; track column; let i = $index) {
                <div class="info-item" [id]="'b2bUser-info-' + userIndex + '-' + i">
                  <typography variant="mat-caption-1" weight="regular" class="info-label" [id]="'b2bUser-info-label-' + userIndex + '-' + i">{{ column.label }}</typography>
                  <typography variant="mat-body-2" weight="bold" [id]="'b2bUser-info-value-' + userIndex + '-' + i">
                    @if (column.key === 'Subtotal') {
                      {{ getUserCurrencySymbol(user) }}{{ user[column.key] | number:'1.2-2' }}
                    } @else {
                      {{ user[column.key] }}
                    }
                  </typography>
                </div>
              }
            </div>
          </mat-expansion-panel-header>
          <div class="panel-content">
            <app-b2b-user-cart [user]="user" [userIndex]="userIndex" [customerId]="customerId" [bpNumber]="bpNumber" (cartItemsLoaded)="onCartItemsLoaded($event)"></app-b2b-user-cart>
          </div>
        </mat-expansion-panel>
      }
    </div>
  }

  @if (totalPages > 0) {
    <div class="pagination-container">
      <ds-paper elevation="elevation_none" borderRadius="radius_XS" outline="outlined" insidePaddingTop="top-spacing_S" insidePaddingBottom="bottom-spacing_S">
        <div class="pagination">
          @if (!loading) {
            <div class="flex-item-2">
              <b>{{ pageOffset + 1 }} - {{ pageOffset + currentPageItemCount }}</b> {{appStrings.pagination_of}} <b>{{ totalRecords }}</b>
            </div>
          }
          <ds-pagination
            id="b2bUsers-pagination"
            [totalPages]="totalPages"
            paginationDisplay="large"
            buttonTypes="nextPrevFirstLast"
            (pageChanged)="loadPage($event)"
          ></ds-pagination>
          <div class="flex-item-2"></div>
        </div>
      </ds-paper>
    </div>
  }
</div>

<!-- Mobile template -->
<div class="mobile" *appIsMobile>
  @if (totalRecords) {
    <div>
      @for (user of users; track user; let userIndex = $index) {
        <ds-paper elevation="elevation_none" borderRadius="radius_S" outline="outlined"
          class="mobile-paper-nested-panel" insidePaddingTop="top-spacing_none" insidePaddingBottom="bottom-spacing_none"
          insidePaddingLeft="left-spacing_none" insidePaddingRight="right-spacing_none">
          <mat-expansion-panel [id]="'b2bUser-expansion-panel-mobile-' + userIndex" hideToggle class="mobile mobile-nested-panel" (opened)="onPanelOpened(userIndex)">
            <mat-expansion-panel-header [id]="'b2bUser-expansion-panel-header-mobile-' + userIndex">
              <mat-panel-title [id]="'b2bUser-expansion-panel-title-mobile-' + userIndex">
                <app-b2b-cart-summary-notifications [cartItems]="getUserCartItems(userIndex)">
                </app-b2b-cart-summary-notifications>
                <div class="title-container">
                  <span class="card-header">
                    <span [id]="'b2bUser-title-mobile-' + userIndex" class="title">{{ user.FirstName + ' ' + user.LastName }}</span>
                    <span [id]="'b2bUser-subtitle-mobile-' + userIndex" class="subtitle">
                      {{ user.Email }} | {{ user.itemsInCart }} {{appStrings.b2bCart_itemsInCart}}
                    </span>
                  </span>
                  <div class="mobile-card-header-actions">
                    <span [id]="'b2bUser-header-closed-mobile-' + userIndex"
                    class="crm-industrial-font icon-keyboard-arrow-down"></span>
                    <span [id]="'b2bUser-header-opened-mobile-' + userIndex"
                    class="crm-industrial-font icon-keyboard-arrow-up"></span>
                  </div>
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ds-divider></ds-divider>
            <div class="content">
              <div class="row">
                <div class="column">
                  <typography [id]="'b2b-role-label-mobile-' + userIndex" class="info-label" variant="caption-2" weight="regular">B2B Role</typography>
                  <typography [id]="'b2b-role-mobile-' + userIndex" variant="caption-1" weight="bold">{{ user.RoleDescription }}</typography>
                </div>
                <div class="column">
                  <typography [id]="'username-label-mobile-' + userIndex" class="info-label" variant="caption-2" weight="regular">User Name</typography>
                  <typography [id]="'username-mobile-' + userIndex" variant="caption-1" weight="bold">{{ user.UserName }}</typography>
                </div>
              </div>
              <div class="row">
                <div class="column full-width">
                  <typography [id]="'phone-label-mobile-' + userIndex" class="info-label" variant="caption-2" weight="regular">Phone Number</typography>
                  <typography [id]="'phone-mobile-' + userIndex" variant="caption-1" weight="bold">{{ user.Phone }}</typography>
                </div>
              </div>
            </div>
            <ds-divider></ds-divider>
            <mat-expansion-panel [id]="'b2bUser-cart-subtotal-mobile-' + userIndex" hideToggle class="two-columns grey" [expanded]="true">
              <div class="mobile-subtotal">
                <typography [id]="'subtotal-label-mobile-' + userIndex" variant="caption-2" weight="regular">Subtotal ({{ user.itemsInCart }} items)</typography>
                <typography [id]="'subtotal-mobile-' + userIndex" variant="caption-1" weight="bold">{{ getUserCurrencySymbol(user) }}{{ user.Subtotal | number:'1.2-2' }}</typography>
              </div>
            </mat-expansion-panel>
            <app-b2b-user-cart [user]="user" [userIndex]="userIndex" [customerId]="customerId" [bpNumber]="bpNumber" (cartItemsLoaded)="onCartItemsLoaded($event)"></app-b2b-user-cart>
          </mat-expansion-panel>
          <div class="mobile-nested-panel-footer">
            <ds-divider></ds-divider>
            <div class="button-container mobile-nested-panel-footer-actions">
              @if (user.itemsInCart > 0) {
                <ng-container *ngTemplateOutlet="editCartButton; context: {userIndex: userIndex}"></ng-container>
                <ng-container *ngTemplateOutlet="deleteCartButton; context: {userIndex: userIndex}"></ng-container>
                <ng-container *ngTemplateOutlet="generateQuoteButton; context: {userIndex: userIndex}"></ng-container>
              } @else {
                <ng-container *ngTemplateOutlet="addToCartButton; context: {userIndex: userIndex}"></ng-container>
              }
            </div>
          </div>
        </ds-paper>
      }
    </div>
  }

  @if (totalPages > 0) {
    <div class="pagination-container-mobile">
      <ds-paper elevation="elevation_none" borderRadius="radius_XS" outline="outlined"
        insidePaddingTop="top-spacing_S" insidePaddingBottom="bottom-spacing_S"
        insidePaddingLeft="left-spacing_S" insidePaddingRight="right-spacing_S">
        <ds-pagination
          id="b2bUsers-pagination-mobile"
          [totalPages]="totalPages"
          paginationDisplay="large"
          buttonTypes="nextPrevFirstLast"
          (pageChanged)="loadPage($event)"
        ></ds-pagination>
      </ds-paper>
    </div>
  }
</div>

@if (!totalRecords && !loading) {
  <div id="emptyB2bUsersState" class="empty">
    <typography id="emptyB2bUsersMessage" variant="mat-headline-6" weight="regular">{{appStrings.noResults}}</typography>
  </div>
}

@if (loading || generateQuoteLoading) {
  <div class="overlay full">
    <ds-progress-spinner id="b2bUsersLoader"></ds-progress-spinner>
    <typography id="loadingMessage" class="text-center">{{appStrings.pleaseWait}}</typography>
  </div>
}

<ng-template #editCartButton let-userIndex="userIndex">
  <ds-button [id]="'b2bUser-edit-cart-button-' + userIndex" shape="square" [size]="isMobile ? 'small' : 'medium'" type="tertiary" variant="label-icon"
    icon="edit" [label]="appStrings.button_editCart" iconPosition="left" iconStyle="material-icons-outlined"
    (onClick)="navigateToEditCart(users[userIndex])">
  </ds-button>
</ng-template>

<ng-template #deleteCartButton let-userIndex="userIndex">
  <ds-button [id]="'b2bUser-delete-cart-button-' + userIndex" shape="square" [size]="isMobile ? 'small' : 'medium'" type="tertiary" variant="label-icon"
    icon="delete" [label]="appStrings.button_deleteCart" iconPosition="left" iconStyle="material-icons-outlined"
    (onClick)="deleteCart(users[userIndex], $event)">
  </ds-button>
</ng-template>

<ng-template #addToCartButton let-userIndex="userIndex">
  <ds-button [id]="'b2bUser-add-to-cart-button-' + userIndex" shape="square" [size]="isMobile ? 'small' : 'medium'" type="secondary" variant="label-only" [label]="appStrings.button_addToCart"
  (onClick)="navigateToEditCart(users[userIndex])"></ds-button>
</ng-template>

<ng-template #generateQuoteButton let-userIndex="userIndex">
  <ds-button [id]="'b2bUser-generate-quote-button-' + userIndex" shape="square" [size]="isMobile ? 'small' : 'medium'" type="secondary" variant="label-only" [label]="appStrings.button_generateQuote"
  (onClick)="generateQuote(users[userIndex], $event, userIndex)"></ds-button>
</ng-template>

<ds-dialog
  id="deleteCartDialog"
  [title]="appStrings.b2bCart_deleteCartDialogTitle"
  [description]="appStrings.b2bCart_deleteCartDialogDescription"
  [actionButtons]="deleteDialogButtons"
  [open]="deleteCartDialogOpen$">
</ds-dialog>

<ds-dialog
  id="generateQuoteDialog"
  [title]="appStrings.b2bCart_generateQuoteDialogTitle"
  [description]="appStrings.b2bCart_generateQuoteDialogDescription"
  [actionButtons]="generateQuoteDialogButtons"
  [open]="generateQuoteDialogOpen$">
</ds-dialog>
